export class newQuestionDto {
  id?: string;
  questionText?: string;
  fibQuestionAnswer?: string;
  questionType?: string;
  optionList?: optionList;
  groups?: addGroupDto;
}

export class optionList {
  Option?: string;
  CorrectOption?: boolean;
}

export class addGroupDto {
  id?: string;
  name?: string;
}

export class addQuestionToGroupDto {
  groupId?: any[];
  questionId?: any[];
}

export class TechnicalQuestionDto {
  mobileNumber?: string;
  driveId?: string;
  userAssessmentDriveSetId?: string;
}
